import { render, staticRenderFns } from "./VineyardsModule.vue?vue&type=template&id=e0583862&scoped=true"
import script from "./VineyardsModule.vue?vue&type=script&lang=js"
export * from "./VineyardsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0583862",
  null
  
)

export default component.exports